module.exports = __webpack_public_path__ + "media/images/emblems/Heimiswil-coat_of_arms-18eeeb5cc10f085f85b802dc965e4861.svg";